import React from "react";
import BannerSection from "./sections/BannerSection";
import DescriptionSection from "./sections/DescriptionSection";
import MapSection from "./sections/MapSection";
import SplitSection from "./sections/SplitSection";
import Footer from "../Footer";

function Home() {

    return (
        <>
            <BannerSection />

            <DescriptionSection />

            <MapSection />

            <SplitSection />

            <Footer />
        </>
    );
}

export default Home;